import React, { ReactNode } from "react";

export default class MountAfterDelay extends React.Component<{
  timeout: number;
  placeholder?: ReactNode;
  render?: (ready: boolean) => ReactNode;
  children?: ReactNode;
}> {
  state = {
    ready: false,
  };

  timeoutId: number | null = null;

  componentDidMount() {
    this.timeoutId = window.setTimeout(
      () => this.setReady(),
      this.props.timeout
    );
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  setReady() {
    this.timeoutId = null;
    this.setState({
      ready: true,
    });
  }

  render() {
    if (this.props.render) {
      return this.props.render(this.state.ready);
    }
    if (this.state.ready) {
      return this.props.children;
    }
    return this.props.placeholder || null;
  }
}
